import { Component, Input } from '@angular/core';
import { CircularGauge, GaugeArc } from '../circular-gauge/circular-gauge';

@Component({
  selector: 'app-analyst-gauge',
  imports: [CircularGauge],
  standalone: true,
  templateUrl: './analyst-gauge.html',
  styleUrl: './analyst-gauge.scss',
})
export class AnalystGauge {
  @Input() value = 85;
  @Input() sellValue = 0;
  @Input() size = 52;
  @Input() strokeWidth = 8;
  // Defaults match V2's own usage exactly — override only where a consumer needs a different
  // (e.g. V3-specific) red/green token.
  @Input() positiveColor = 'var(--v2-table-positive)';
  @Input() negativeColor = 'var(--v2-table-negative)';

  // Sell arc renders first (underneath), starting where the buy arc ends, going clockwise
  // from the top; buy arc renders last (on top), starting at the top.
  get arcs(): GaugeArc[] {
    const buyDegrees = (this.value / 100) * 360;
    return [
      { ratio: this.sellValue / 100, color: this.negativeColor, startDegrees: buyDegrees },
      { ratio: this.value / 100, color: this.positiveColor },
    ];
  }
}
